import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PrimaryButton, DefaultButton } from '@bingads-webui-react/fabric-control';
import { withRawStyles } from '@bingads-webui-react/with-raw-styles';

import { getActionButtonRawStyles } from '../styles/tiles-grid-cell-action-button-style';

const ActionButton = ({
  text, iconName, onClick, className, primary, styles,
}) => {
  const iconProps = useMemo(() => ({ iconName }), [iconName]);

  const Button = primary ? PrimaryButton : DefaultButton;
  return (
    <Button
      text={text}
      iconProps={iconProps}
      styles={styles}
      onClick={onClick}
      className={classnames('cell-button', className)}
    />
  );
};

ActionButton.propTypes = {
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  primary: PropTypes.bool,
  // injected
  styles: PropTypes.shape().isRequired,
};

ActionButton.defaultProps = {
  className: undefined,
  primary: true,
};

export const TilesGridCellActionButton
  = withRawStyles(ActionButton, getActionButtonRawStyles);
